import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { Edit2 } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableStampsLogs = ({ useFetchInit }) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllStampLogs } = FetchData
    const { dataStampLogs, loadingFetchAllStampLogs } = fetchAllStampLogs

    // ------------------------------------------------ Actions
    const { 
        handleClickFetchSpecificStampLog
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "date_transaction", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "type_transaction", headerName: "TIPO", minWidth: 100, filter: true },
        { field: "stamp", headerName: "TIMBRE", minWidth: 200, filter: true },
        { field: "quantity", headerName: "CANTIDAD", minWidth: 150, filter: true },
        { field: "observations", headerName: "OBSERVACIONES", minWidth: 350, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idstamplogs } = params.data
                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificStampLog(idstamplogs)}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllStampLogs)&& (<LinearLoading />)}
            <CustomTableData 
                // datos (listados, individuales)
                rowConfig={dataStampLogs}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
